import { useState } from 'react';

import endpoints from '../../../../../../api/endpoints';
import { PortalError } from '../../../../../common/business-error';
import { handleResponseError } from '../../../../../../api/handleResponseError';
import { fetchWithTokenRefresh } from '../../../../../../api/fetchWithTokenRefresh';

import { getCreditHistoryBusinessError } from '../businessErrors';
import { WalletCreditsHistoryResponse } from '../../add-funds-to-your-wallet/interfaces';

export const useUpdateCreditsHistory = () => {
  const [creditsHistory, setCreditsHistory] = useState<WalletCreditsHistoryResponse | null>(null);
  const [creditsHistoryLoading, setLoading] = useState<boolean>(false);
  const [creditsHistoryError, setError] = useState<PortalError>(null);

  const updateCreditsHistory = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetchWithTokenRefresh(endpoints.walletCredits);

      if (response.status !== 200) {
        await handleResponseError(response);
      }

      const jsonResponse = await response.json();

      setCreditsHistory(jsonResponse);
      setLoading(false);
    } catch (e) {
      const { message, severity } = getCreditHistoryBusinessError(e);

      setError({ message, severity });
      setLoading(false);
    }
  };

  return {
    creditsHistory,
    creditsHistoryLoading,
    creditsHistoryError,
    updateCreditsHistory
  };
};
